import { AuthGate, useAuth } from '@entities/auth'
import { MenuRow } from '@shared/ui/menu-row'
import { useNavigate } from '@tanstack/react-router'
import { HiMiniDocumentText, HiMiniShieldCheck } from 'react-icons/hi2'

const MENU_ROWS = [
  { icon: HiMiniDocumentText, label: '이용약관', href: '/terms' },
  { icon: HiMiniShieldCheck, label: '개인정보처리방침', href: '/privacy' },
] as const

export function MenuSection() {
  const navigate = useNavigate()

  const { clearAuth } = useAuth()

  return (
    <div className="flex flex-col">
      {MENU_ROWS.map((row) => (
        <MenuRow
          key={row.label}
          icon={row.icon}
          label={row.label}
          onClick={() => {
            void navigate({ to: row.href })
          }}
        />
      ))}
      <AuthGate fallback={null}>
        <hr className="divider divider-border my-1" />
        <MenuRow.Action
          label="로그아웃"
          onClick={() => {
            clearAuth()
            void navigate({ to: '/' })
          }}
        />
      </AuthGate>
    </div>
  )
}
